import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Sparkles, Send } from "lucide-react";
import { toast } from "sonner";

const ESEMPI = [
  "Voglio un'app per registrare i controlli qualità in linea",
  "Mi serve un gestionale piccolo per le commesse di stampaggio",
  "Voglio un portale per i fornitori per caricare le bolle",
  "Mi serve un sistema per prenotare le sale riunioni",
  "Voglio registrare le manutenzioni sulle macchine con foto",
  "Mi serve un mini CRM per i clienti del nostro reparto vendite",
];

export default function Costruisci() {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (msg) => {
    if (msg.trim().length < 20) {
      toast.error("Descrivi un po' di più cosa ti serve (almeno 20 caratteri)");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/custom-apps", { initial_prompt: msg });
      nav(`/costruisci/${data.id}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto py-8">
      <div className="adr-overline mb-4 text-[#C8102E] text-center">App Builder · Free-Form</div>
      <h1 className="serif text-4xl sm:text-5xl font-semibold tracking-tight text-[#1A1A1A] leading-[1.05] mb-4 text-center">
        Descrivimi l'applicazione di cui hai bisogno
      </h1>
      <p className="text-[#555555] text-center mb-10 max-w-xl mx-auto">
        Spiegamela in italiano semplice. Un agente AI ti farà qualche domanda, scriverà un Documento di Bisogno comprensibile e poi costruirà la prima versione.
      </p>

      <form onSubmit={(e) => { e.preventDefault(); submit(text); }} className="relative" data-testid="costruisci-form">
        <textarea
          data-testid="costruisci-input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Es. Vorrei un'app dove i capi turno registrano i controlli qualità delle linee, possono allegare foto dei difetti, e ogni venerdì mi arriva un report via email..."
          className="adr-input min-h-[160px] resize-none text-base pr-14"
        />
        <button type="submit" disabled={loading || text.length < 20} className="absolute right-3 bottom-3 w-11 h-11 rounded-md text-white flex items-center justify-center disabled:opacity-40" style={{ background: "#C8102E" }} data-testid="costruisci-send">
          <Send className="w-4 h-4" />
        </button>
      </form>

      <div className="mt-10">
        <div className="adr-overline mb-3 text-center">Esempi per ispirarti</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {ESEMPI.map((e, i) => (
            <button key={i} onClick={() => submit(e)} className="adr-card text-left p-4" data-testid={`costruisci-esempio-${i}`}>
              <div className="flex items-start gap-3">
                <Sparkles className="w-4 h-4 text-[#0F3D6B] flex-shrink-0 mt-0.5" />
                <span className="text-sm">{e}</span>
              </div>
            </button>
          ))}
        </div>
      </div>

      <div className="text-xs text-[#555555] mt-8 text-center max-w-2xl mx-auto leading-relaxed">
        Lo stack tecnico è fissato (Next.js + FastAPI + PostgreSQL). Sono escluse: app mobile native, motori di calcolo complessi proprietari, sistemi real-time mission-critical. Quota mensile: 5 applicazioni per organizzazione.
      </div>
    </div>
  );
}
